import script from "./PushButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PushButton.vue?vue&type=script&setup=true&lang=ts"

import "./PushButton.vue?vue&type=style&index=0&id=2a3a76d2&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a3a76d2"]])

export default __exports__